class Counter {
    constructor() {
        /**
         * The last number used. The next number will be 1 more than this.
         *
         * @type {number}
         */
        this.value = 0;
    }

    next() {
        return ++this.value;
    }

    reset() {
        this.value = 0;
    }

    set(value) {
        this.value = value;
    }

    /**
     * Set the value to the given value, but only of if the given value is greater than existing value.
     *
     * @param {number} value
     */
    setMin(value) {
        if (value > this.value) {
            this.set(value);
        }
    }
}

module.exports = Counter;
